import { useState } from 'react';

function useBind(initialValue) {
  var _a = useState(initialValue),
      value = _a[0],
      setValue = _a[1];

  return {
    get value() {
      return value;
    },

    set value(val) {
      setValue(val);
    }

  };
}

export { useBind };